import { render, staticRenderFns } from "./FoodGroup.vue?vue&type=template&id=47e9f20e&"
import script from "./FoodGroup.vue?vue&type=script&lang=ts&"
export * from "./FoodGroup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports